import * as mutationType from "../mutation_types";

const state = {
  all: {},
  mission_statements: [],
  review_questions: [],
  review_question_categories: []
};

const getters = {
  all: state => state.all,
  corevalue_categories: state => state.all.corevalue_categories,
  employee_sizes: state => state.all.employee_sizes,
  industries: state => state.all.industries,
  admin_system_roles: state =>
    state.all.system_roles?.filter(role => role.isAdmin) ?? [],
  app_system_roles: state =>
    state.all.system_roles?.filter(role => role.isAdmin == false) ?? [],
  mission_statements: state => state.mission_statements,
  survey_question_types: state => state.all.survey_question_types,
  company_plan_types: state => state.all.company_plan_types,
  goal_statuses: state => state.all.goal_statuses || [],
  review_frequencies: state => state.all.review_frequencies,
  resource_types: state => state.all.resource_types,
  notification_types: state => state.all.notification_types,
  business_metric_unit_types: state => state.all.business_metric_unit_types,
  insight_categories: state => state.all.insight_categories,
  report_types: state => state.all.report_types,
  review_question_categories: state => state.review_question_categories,
  review_questions: state => state.review_questions,
  levels: state => state.all.levels,
  custom_field_types: state => state.all.custom_field_types
};

const actions = {
  getLookups({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/lookups")
        .then(res => {
          commit(mutationType.SET_LOOKUPS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getMissionStatements({ commit }, industryId) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/lookups/missionstatements?industryId=" + industryId)
        .then(res => {
          commit(mutationType.SET_MISSION_STATEMENTS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  }
};

const mutations = {
  [mutationType.SET_LOOKUPS](state, list) {
    state.all = list;
  },
  [mutationType.SET_MISSION_STATEMENTS](state, list) {
    state.mission_statements = list;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
